/**
 * Footer privacy links: <li data-privacy-link="cookies|opt-out" hidden>…</li>
 *
 * Reveals each link only when Shopify's own Customer Privacy features apply to the visitor,
 * so nothing shows (and no broken link appears) until the merchant turns them on in
 * Settings > Customer privacy:
 *  - "cookies": shown when Shopify's cookie banner is active for the visitor's region
 *    (customerPrivacy.shouldShowBanner()) or the banner script is loaded. The link's href ends in
 *    #shopifyReshowConsentBanner, which Shopify's banner script handles natively to reopen the
 *    cookie preferences dialog. This script never records or changes consent.
 *  - "opt-out": shown when the visitor is in a region where Shopify's data sharing opt-out page
 *    applies (customerPrivacy.saleOfDataRegion()). The href is Shopify's own opt-out page,
 *    resolved in Liquid; the item isn't rendered at all when that page doesn't exist.
 * Uses only the Consent Tracking API that Shopify loads via Shopify.loadFeatures.
 */
const items = document.querySelectorAll('[data-privacy-link]');

function reveal(api) {
  for (const item of items) {
    const type = item.getAttribute('data-privacy-link');
    let show = false;
    try {
      if (type === 'cookies') {
        show = Boolean(window.privacyBanner) || (typeof api?.shouldShowBanner === 'function' && api.shouldShowBanner() === true);
      } else if (type === 'opt-out') {
        show = typeof api?.saleOfDataRegion === 'function' && api.saleOfDataRegion() === true;
      }
    } catch {
      show = false;
    }
    if (show) item.hidden = false;
  }
}

if (items.length) {
  const existing = window.Shopify?.customerPrivacy;
  if (existing && typeof existing.shouldShowBanner === 'function') {
    reveal(existing);
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) return;
      reveal(window.Shopify.customerPrivacy);
    });
  }
}
